import {useEffect, useState} from "react";
import {Route, Routes, useNavigate} from "react-router-dom";
import Work from "./View/Work";
import Footer from "./View/Footer";
import Header from "./View/Header";
import Home from "./View/Home";
import Undefined from "./View/Undefined";
import Articles from "./View/Articles";
import NavigationTabType from "./Model/NavigationTabType";
import GitRepo from "./Model/GitRepo";
import Article from "./Model/Article";

function App() {
    const navigate = useNavigate();
    const [githubRepos, setGithubRepos] = useState<GitRepo[]>([]);
    const [articles, setArticles] = useState<Article[]>([]);

    useEffect(() => {
        const fetchGithubData = async () => {
            try {
                const response = await fetch(
                    'https://api.github.com/users/lukaspowers/repos', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }

                const result = await response.json();
                result.sort((a: any, b: any) => new Date(b.pushed_at).getTime() - new Date(a.pushed_at).getTime());

                const displayCommits = result.slice(0, 5);

                let repos: GitRepo[] = [];
                displayCommits.forEach((repo: GitRepo) => {
                    const newRepo: GitRepo = {
                        name:  repo.name,
                        html_url: repo.html_url,
                        description: repo.description,
                        pushed_at: repo.pushed_at,
                        language: repo.language
                    };
                    repos.push(newRepo);
                });

                addRepoData(repos);
            } catch (err) {
                console.log(err);
            }
        };

        const fetchASGithubData = async () => {
            try {
                const response = await fetch(
                    'https://api.github.com/orgs/Agape-Software-LLC/repos', {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }

                const result = await response.json();
                result.sort((a: any, b: any) => new Date(b.pushed_at).getTime() - new Date(a.pushed_at).getTime());

                const displayCommits = result.slice(0, 5);

                let repos: GitRepo[] = [];
                displayCommits.forEach((repo: GitRepo) => {
                    const newRepo: GitRepo = {
                        name:  repo.name,
                        html_url: repo.html_url,
                        description: repo.description,
                        pushed_at: repo.pushed_at,
                        language: repo.language
                    };
                    repos.push(newRepo);
                });

                addRepoData(repos);
            } catch (err) {
                console.log(err);
            }
        };

        const fetchArticleData = async () => {
            try {
                const response = await fetch(
                      `https://api.rss2json.com/v1/api.json?rss_url=https://lukaspowers.substack.com/feed`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }

                const result = await response.json();

                let articles: Article[] = [];
                result.items.forEach((repo: any) => {
                    const timestamp = new Date(repo.pubDate).getTime(); // milliseconds
                    const unixSeconds = Math.floor(timestamp / 1000); // seconds

                    const article: Article = {
                        id: repo.title,
                        title: repo.title,
                        date: unixSeconds,
                        url: repo.link
                    };
                    articles.push(article);
                });

                articles.sort((a, b) => b.date - a.date);

                addArticleData(articles);
            } catch (err) {
                console.log(err);
            }
        };

        const fetchASArticleData = async () => {
            try {
                const response = await fetch(
                      `https://api.rss2json.com/v1/api.json?rss_url=https://agapesoftware.substack.com/feed`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    });

                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }

                const result = await response.json();

                let articles: Article[] = [];
                result.items.forEach((repo: any) => {
                    const timestamp = new Date(repo.pubDate).getTime(); // milliseconds
                    const unixSeconds = Math.floor(timestamp / 1000); // seconds

                    const article: Article = {
                        id: repo.title,
                        title: repo.title,
                        date: unixSeconds,
                        url: repo.link
                    };
                    articles.push(article);
                });

                articles.sort((a, b) => b.date - a.date);

                addArticleData(articles);
            } catch (err) {
                console.log(err);
            }
        };

        if (githubRepos.length === 0) {
            fetchGithubData();
            fetchASGithubData();
        }

        if (articles.length === 0) {
            fetchArticleData();
            fetchASArticleData();
        }

    }, [githubRepos]);

    function addRepoData(repos: GitRepo[]) {
        setGithubRepos((prevRepos) => {
            const combined = [...prevRepos, ...repos];

            return combined.sort((a, b) =>
                new Date(b.pushed_at).getTime() - new Date(a.pushed_at).getTime()
            );
        });
    }

    function addArticleData(articles: Article[]) {
        setArticles((prevArticles) => {
            const combined = [...prevArticles, ...articles];

            return combined.sort((a, b) =>
                new Date(b.date).getTime() - new Date(a.date).getTime()
            );
        });
    }

    function changedTab(navigationTab: NavigationTabType) {
        switch (navigationTab) {
            case NavigationTabType.home : {
                navigate("/");
                break;
            }
            case NavigationTabType.work : {
                navigate("/work");
                break;
            }
            case NavigationTabType.articles : {
                navigate("/articles");
                break;
            }
            default : {
                navigate("/");
                break;
            }
        }
    }

    return (
        <div>

            <Header onTabChanged={changedTab} />

            <Routes>

                <Route path="/" element={<Home />} />
                <Route path="/work" element={<Work inRepos={githubRepos} />} />
                <Route path="/articles" element={<Articles inArticles={articles} />} />
                <Route path="*" element={<Undefined />} />

            </Routes>

            <Footer />


        </div>
    );
}

export default App;
